"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.World = exports.isInsideWorldLimits = exports.getWorld = void 0;

var validation_1 = require("../validation");
/**
 * Get World
 * @alpha
 */


function getWorld() {
  return {
    validWorldRanges: [{
      xMin: -150,
      yMin: -150,
      xMax: 150,
      yMax: 150
    }, {
      xMin: 62,
      yMin: 151,
      xMax: 162,
      yMax: 158
    }, {
      xMin: 151,
      yMin: 144,
      xMax: 162,
      yMax: 150
    }, {
      xMin: 151,
      yMin: 59,
      xMax: 163,
      yMax: 143
    }]
  };
}

exports.getWorld = getWorld;
/**
 * Check if is inside World Limits
 * @alpha
 */

function isInsideWorldLimits(x, y) {
  var validWorldRanges = getWorld().validWorldRanges;

  var _iterator = _createForOfIteratorHelper(validWorldRanges),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var range = _step.value;

      if (x >= range.xMin && x <= range.xMax && y >= range.yMin && y <= range.yMax) {
        return true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return false;
}

exports.isInsideWorldLimits = isInsideWorldLimits;
/**
 * @alpha
 */

var World;

(function (World) {
  World.schema = {
    type: 'object',
    required: ['validWorldRanges'],
    properties: {
      validWorldRanges: {
        type: 'array',
        default: [{
          xMin: -150,
          yMin: -150,
          xMax: 150,
          yMax: 150
        }],
        items: {
          type: 'object',
          required: ['xMin', 'yMin', 'xMax', 'yMax'],
          properties: {
            xMin: {
              type: 'integer'
            },
            yMin: {
              type: 'integer'
            },
            xMax: {
              type: 'integer'
            },
            yMax: {
              type: 'integer'
            }
          }
        }
      }
    },
    additionalProperties: false
  };
  World.validate = (0, validation_1.generateValidator)(World.schema);
})(World = exports.World || (exports.World = {}));